<template>
  <modal :show="visible" modalClasses="modal-xl">
    <template #header></template>
    <h3 class="text-center" v-if="type == 'receiver'">
      {{
        customer.id ? "Cập nhật người nhận hàng" : "Thêm mới người nhận hàng"
      }}
    </h3>
    <h3 v-else class="text-center">
      {{ customer.id ? "Cập nhật khách hàng" : "Thêm mới khách hàng" }}
    </h3>
    <loading
      :active.sync="isPending"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <step ref="step" :steps="steps" @next="nextStep" @complete="doSave">
      <template v-slot="{ currentStep }">
        <div>
          <div v-if="currentStep == 0">
            <ValidationObserver ref="csInfo" v-slot="{ handleSubmit }">
              <form role="form" @submit.prevent="handleSubmit">
                <b-row>
                  <b-col cols="6">
                    <base-input
                      label="Mã khách hàng"
                      placeholder="Nếu không nhập hệ thống sẽ tự sinh"
                      v-model="customer.code"
                    ></base-input>
                    <ValidationProvider
                      name="Tên khách hàng"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <base-input
                        label="Tên khách hàng"
                        :error="errors[0]"
                        v-model="customer.name"
                        :valid="errors.length == 0"
                      ></base-input>
                    </ValidationProvider>
                    <base-input
                      type="text"
                      label="Tên viết tắc"
                      v-model="customer.short_name"
                    ></base-input>
                    <base-input
                      type="number"
                      label="Mã số thuế"
                      v-model="customer.taxCode"
                    ></base-input>
                    <ValidationProvider
                      v-if="type == ''"
                      name="Thuế suất"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <base-input
                        type="number"
                        label="Thuế suất"
                        :error="errors[0]"
                        v-model="customer.tax"
                        :valid="errors.length == 0"
                      ></base-input>
                    </ValidationProvider>
                  </b-col>
                  <b-col cols="6">
                    <base-input
                      label="Email"
                      v-model="customer.email"
                    ></base-input>
                    <base-input
                      label="Đặt thù khách hàng"
                      v-model="customer.fax"
                    ></base-input>
                    <base-input
                      label="website"
                      v-model="customer.website"
                    ></base-input>
                    <base-input
                      label="Số điện thoại"
                      v-model="customer.mobile"
                    ></base-input>
                    <base-input
                      label="Địa chỉ"
                      v-model="customer.address"
                    ></base-input>
                  </b-col>
                  <!-- <b-col cols="12">

                  </b-col> -->
                </b-row>
              </form>
            </ValidationObserver>
          </div>
          <div v-else-if="currentStep == 1">
            <ValidationObserver v-slot="{ handleSubmit }">
              <form role="form" @submit.prevent="handleSubmit">
                <base-input
                  label="Ngành nghề"
                  v-model="customer.career"
                ></base-input>
                <base-input
                  label="Số lượng nhân viên"
                  v-model="customer.employeeNumber"
                ></base-input>
                <base-input
                  label="Quy mô nhà xưởng"
                  v-model="customer.factoryScale"
                ></base-input>
                <base-input
                  label="Thời hạn thanh toán (ngày)"
                  :mask="'number'"
                  v-model="customer.debtDuration"
                ></base-input>
                <base-input
                  label="Hạn mức thanh toán (VNĐ)"
                  :mask="'number'"
                  v-model="customer.debtAmount"
                ></base-input>
              </form>
            </ValidationObserver>
          </div>
          <div v-else>
            <base-upload
              :preview="uploadPreview"
              @doUpload="doUpload"
            ></base-upload>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <button
          type="button"
          @click="handleClose"
          class="btn btn-dark"
          data-dismiss="modal"
        >
          Đóng (Esc)
        </button>
      </template>
    </step>
    <event
      @doCancel="handleClose"
      @doSave="doSave(0)"
      @doSaveContinue="doSave(1)"
    ></event>
  </modal>
</template>

<script>
import { customerService, uploadService } from "@/_services";
export default {
  data() {
    return {
      visible: false,
      steps: ["Thông tin", "Chi tiết", "Hình đại diện"],
      customer: {
        debtDuration: 365,
        debtAmount: 10000000000,
        short_name: "",
        tax: 10
      },
      groupId: 1,
      type: "",
      uploadPreview: "/img/placeholder/default.jpg",
      isPending: false
    };
  },
  methods: {
    nextStep(currentStep, cb) {
      if (currentStep == 0) {
        this.$refs.csInfo.validate().then(success => {
          cb(success);
        });
      } else {
        cb(true);
      }
    },
    async doSave(type) {
      var self = this;
      if (!this.visible) return;
      let validate = this.$refs.csInfo
        ? await this.$refs.csInfo.validate()
        : true;
      if (!validate) return false;
      this.isPending = true;
      if (this.customer.id) {
        customerService
          .update(this.customer.id, { customer: this.customer })
          .then(() => {
            self.$alertify.success("Cập nhật thành công");
            self.$emit("submit:success");
            if (type == 0) {
              self.visible = false;
            } else {
              self.$refs.step.currentStep = 0;
            }
          })
          .finally(() => {
            self.isPending = false;
          });
      } else {
        customerService
          .create({ customer: this.customer, groupId: this.groupId })
          .then(() => {
            self.$alertify.success("Thêm thành công");
            self.customer = {};
            self.$emit("submit:success");
            if (type == 0) {
              this.visible = false;
              this.isPending = false;
            } else {
              self.$refs.step.currentStep = 0;
            }
          })
          .finally(() => {
            self.isPending = false;
          });
      }
    },
    handleClose() {
      this.customer = {};
      this.visible = false;
    },
    doUpload(data, cb) {
      var self = this;
      this.uploadPreview = data.preview;
      uploadService.avatar({ file: data.file }).then(res => {
        self.customer.avatar = res.data.path;
        self.$refs.step.currentStep = 3;
        console.log("xxxx", self.customer);
        cb();
      });
      console.log(data);
    },
    setStep(index) {
      this.$refs.step.currentStep = index;
    },
    setData(customer, type = "") {
      if (!customer || !customer.debtDuration) {
        customer.debtDuration = 365;
        customer.debtAmount = 1000000000;
        customer.short_name = "";
        customer.tax = 10;
      }
      this.customer = customer;
      this.type = type;
      if (type == "receiver") {
        this.groupId = 2;
      }

      if (this.customer.avatar) {
        this.uploadPreview = this.$mediaURI + this.customer.avatar;
      } else {
        this.uploadPreview = "/img/placeholder/default.jpg";
      }
    }
  }
};
</script>

<style lang="scss">
.wrap-drop-img {
  height: 400px;
}
</style>
